// extracted by mini-css-extract-plugin
export default {"main":"styles_main__O4rQw","noPermission":"styles_noPermission__f20nj","btn":"styles_btn__NzSDa"};